import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="w-full max-w-2xl mx-auto" style={{ marginBottom: '48px' }}>
      <div className="relative">
        <Input
          type="search"
          placeholder="Search articles by title, excerpt, or author..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
          <Icon name="Search" size={20} color="var(--color-primary)" />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;